/* import __COLOCATED_TEMPLATE__ from './activity-list.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
let ActivityListComponent = (_class = class ActivityListComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  pendingHeader() {
    return {
      isHeader: true,
      id: 'pending-header',
      title: this.intl.t('banking.shared.activity.pending')
    };
  }
  dateRow(date) {
    return {
      isHeader: true,
      id: date.toISOString(),
      title: this.intl.formatDate(date, {
        month: 'short',
        year: 'numeric',
        day: 'numeric'
      })
    };
  }
  // The ActivityList needs to be flattened to prevent a class of scroll
  // bugs that occur because the nested groups of activities triggers brief
  // glitches in which the Completed section of activities has a height of 0
  // So we flatten the list so that there's no nested groups
  // We also add `id`s to the headers so that we correctly use the `key` property
  // on the #each block in the template
  get flattenedActivityList() {
    const flattenedActivityList = [];

    // First push the pending header and pending activities to the list
    if (this.args.activityList.pending.length > 0) {
      flattenedActivityList.push(this.pendingHeader(), ...this.args.activityList.pending);
    }

    // Next, flatten the completed list of activities and add date headers into it
    this.args.activityList.completed.forEach(month => {
      flattenedActivityList.push(this.dateRow(month.date));
      month.activities.forEach(activity => {
        flattenedActivityList.push(activity);
      });
    });
    return flattenedActivityList;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { ActivityListComponent as default };